import React, { useEffect, useMemo, useState } from "react";
import countriesData from "../data/common/countries.json";
import citiesData from "../data/common/cities.json";

const readStoredSelection = (key) => {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : { country: "", city: "" };
  } catch (error) {
    return { country: "", city: "" };
  }
};

export default function CountryCitySelect({
  storageKey,
  labels,
  showTitle = true,
}) {
  const stored = readStoredSelection(storageKey);
  const [country, setCountry] = useState(stored.country || "");
  const [city, setCity] = useState(stored.city || "");

  const cities = useMemo(() => citiesData[country] || [], [country]);

  useEffect(() => {
    try {
      localStorage.setItem(storageKey, JSON.stringify({ country, city }));
    } catch (error) {
      // no-op
    }
  }, [country, city, storageKey]);

  const handleCountryChange = (value) => {
    setCountry(value);
    setCity("");
  };

  return (
    <div className="space-y-3">
      {showTitle && (
        <div>
          <p className="text-sm font-semibold text-slate-900">{labels.title}</p>
          {labels.subtitle && (
            <p className="mt-1 text-xs text-slate-500">{labels.subtitle}</p>
          )}
        </div>
      )}
      <div className="grid gap-3 md:grid-cols-2">
        <div>
          <label className="text-xs text-slate-500">{labels.countryLabel}</label>
          <select
            className="mt-2 w-full rounded-md border border-slate-200 px-3 py-2 text-sm"
            value={country}
            onChange={(event) => handleCountryChange(event.target.value)}
          >
            <option value="">{labels.countryPlaceholder}</option>
            {countriesData.items.map((item) => (
              <option key={item.code} value={item.code}>
                {item.name}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className="text-xs text-slate-500">{labels.cityLabel}</label>
          <select
            className="mt-2 w-full rounded-md border border-slate-200 px-3 py-2 text-sm"
            value={city}
            onChange={(event) => setCity(event.target.value)}
            disabled={!country}
          >
            <option value="">{labels.cityPlaceholder}</option>
            {cities.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}
